module.exports = __webpack_public_path__ + "img/1.8abd5a8e.png";